import { Module } from 'vuex';
import { CUSTOMER_MANAGEMENT_SET_SELECTED } from '@/modules/customers/store/customer-management.mutations';
import { CUSTOMER_MANAGEMENT_GET_SELECTED } from '@/modules/customers/store/customer-management.getters';

const customerManagement: Module<any, any> = {
    namespaced: true,
    state: {
        customerSelected: {},
    },
    getters: {
        [CUSTOMER_MANAGEMENT_GET_SELECTED](state) {
            return state.customerSelected;
        },
    },
    mutations: {
        [CUSTOMER_MANAGEMENT_SET_SELECTED](state, customer) {
            state.customerSelected = customer;
        },
    },
    actions: {},
};

export default customerManagement;
